import React from 'react'

const Procurement = () => {
  return (
    <div className='mx-auto p-4'>
      Procurement
    </div>
  )
}

export default Procurement
